import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    $(".js-toggle-clue-provide-biz-director").toggle();
  }
}
